// SLBreachedTab.tsx
import { useState, useEffect } from "react";
import { Tabs, Tab } from "@mui/material";
import SLBreachedTask from "./SLBreachedTask";
import { activitySubTabsSx } from "./activityTabsSx";
import { useSlBreachedQuery } from "../../Services/activity/SlBreached";

const SLBreachedTab = () => {
  const [tabIndex, setTabIndex] = useState(() => {
      const savedTabIndex = sessionStorage.getItem("slBreachedTabIndex");
      return savedTabIndex ? Number(savedTabIndex) : 0;
    });
  
    useEffect(() => {
      sessionStorage.setItem("slBreachedTabIndex", tabIndex.toString());
    }, [tabIndex]);

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(_, val) => setTabIndex(val)}
        sx={activitySubTabsSx}
      >
        <Tab label="Tickets" />
        <Tab label="Emails" />
      </Tabs>
   

      <div className="pt-3 px-3 pb-0">
        {tabIndex === 0 && (
          <SLBreachedTask
            task_source="tickets"
            useQueryHook={useSlBreachedQuery}
          />
        )}
        {tabIndex === 1 && (
          <SLBreachedTask
            task_source="emails"
            useQueryHook={useSlBreachedQuery}
          />
        )}
      </div>
    </>
  );
};

export default SLBreachedTab;
